import React from "react";
import {Alert, Box, Button, Stack, Typography} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import {formatDateISO} from "../../utils/helpers";

export default function BookingInfo({reservation, onEditNotes}) {
    if (!reservation) return null;

    return (
        <Box sx={{width: "calc(100% - 32px)", mx: "auto", my: 2}}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{mb: 1}}>
                Détails de la réservation
            </Typography>

            <Box>
                <Box component="div" sx={{mt: 1}}>
                    <Stack spacing={2}>
                        <Box sx={{px: {xs: 1, sm: 2}}}>
                            <Typography variant="subtitle1" gutterBottom>Période</Typography>
                            <Box sx={{
                                display: "flex",
                                flexDirection: {xs: "column", sm: "row"},
                                gap: 1
                            }}>
                                <Typography variant="body2" color="text.secondary">
                                    {formatDateISO(reservation.startTime)} → {formatDateISO(reservation.endTime)}
                                </Typography>
                            </Box>
                        </Box>

                        <Box sx={{px: {xs: 1, sm: 2}}}>
                            <Typography variant="subtitle1" gutterBottom>Objet de la réservation</Typography>
                            <Typography variant="body2" color="text.secondary">{reservation.object}</Typography>
                        </Box>

                        <Box sx={{px: {xs: 1, sm: 2}}}>
                            <Typography variant="subtitle1" gutterBottom>Nombre de personnes</Typography>
                            <Typography variant="body2" color="text.secondary">
                                {reservation.numberOfPeople} personne{reservation.numberOfPeople > 1 ? "s" : ""}
                            </Typography>
                        </Box>

                        <Box sx={{px: {xs: 1, sm: 2}}}>
                            <Typography variant="subtitle1" gutterBottom>Statut</Typography>
                            <Alert severity={reservation.status.severity}>{reservation.status.label}</Alert>
                        </Box>

                        <Box sx={{px: {xs: 1, sm: 2}}} onClick={onEditNotes}>
                            <Box sx={{display: "flex", alignItems: "center", gap: 1}}>
                                <Typography variant="subtitle1" gutterBottom>Notes</Typography>
                                <Button startIcon={<EditIcon/>} sx={{minWidth: "auto", mb: 0.5}}/>
                            </Box>
                            <Typography variant="body2" color="text.secondary">
                                {reservation.notes ? reservation.notes : "Aucune note"}
                            </Typography>
                        </Box>
                    </Stack>
                </Box>
            </Box>
        </Box>
    );
}
